export const dataGridStyleOverride = {
    MuiDataGrid: {
        defaultProps: {
            rowHeight: 36,
        },
        styleOverrides: {
            columnHeader: {
                backgroundColor: "#fff",
            },
        },
    },
};
